import { motion } from "framer-motion";
import { GraduationCap, Users, Heart } from "lucide-react";
import { SectionHead } from "@/components/site/Reveal";

const pillars = [
  {
    icon: GraduationCap,
    title: "Formés à Paris",
    text: "Tous diplômés d'une école d'informatique de Paris, nous partageons la même exigence technique et le même goût du travail bien fait.",
  },
  {
    icon: Users,
    title: "Des associés complémentaires",
    text: "Développement, design, référencement : chaque associé apporte sa spécialité pour travailler sur des projets variés et ambitieux.",
  },
  {
    icon: Heart,
    title: "La passion avant tout",
    text: "Nous nous sommes associés par passion. Créer des sites internet n'est pas qu'un métier : c'est ce qui nous anime au quotidien.",
  },
];

export const Entreprise = () => (
  <section id="entreprise" className="relative py-24 md:py-36" data-testid="entreprise-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHead
        label="L'entreprise"
        title={
          <>
            Une équipe née <span className="text-gradient">par passion.</span>
          </>
        }
        subtitle="Les Amis du Web, c'est l'histoire de plusieurs associés issus d'une école d'informatique de Paris. Par passion du web, nous nous sommes associés pour travailler ensemble sur différents projets : sites vitrines, boutiques, plateformes… Chaque projet est une nouvelle aventure que nous menons avec le même enthousiasme. Nous ne sommes pas une grosse agence impersonnelle : nous prenons le temps de comprendre votre activité."
      />
      <div className="grid md:grid-cols-3 gap-6">
        {pillars.map((p, i) => (
          <motion.div
            key={p.title}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="card-surface rounded-2xl p-8"
            data-testid={`entreprise-pillar-${i}`}
          >
            <p.icon size={22} className="text-[var(--accent-cyan)] mb-5" />
            <h3 className="font-display font-bold text-xl tracking-tight">{p.title}</h3>
            <p className="text-[var(--text-secondary)] text-sm md:text-base mt-3 leading-relaxed">{p.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Entreprise;
